import { ThrowStmt } from '@angular/compiler';
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { MLSListingService } from "src/services/mls-listings.service";
import { UserDetailService } from "src/services/user-details.service";

@Component({
    selector: "app-mls-listings-agent-page",
    templateUrl: "./mls-listings-agent-page.component.html",
    styleUrls: ["./mls-listings-agent-page.component.css"],
})
export class MlsListingsAgentPageComponent implements OnInit {

    listingspage = "/all-listings";
    

    @Input() agentMLS_ID;
    listings : any;

    constructor(
        public route: ActivatedRoute,
        private mlsService: MLSListingService,
        private userService: UserDetailService
    ) {}

    ngOnInit() {
        this.mlsService.getAgentListings(this.agentMLS_ID).subscribe(res => {
            // console.log(res);
            this.listings = res as any;
            //console.log(this.listings.length);
        })

        

    }

    getPrice(x) {
        var price = parseInt(x);
        var final_price = '$' + this.numberWithCommas(price);
        return final_price;

    }


    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    listings_length() {
        if(this.listings.length > 1) {
            return true;
        }
        else {
            return false;
        }
    }

    getListingPageID(listing_id) {
        var link = '/listing/' + listing_id;
        return link;
    }

    
    
}
